import {
  AppBar,
  Badge,
  Box,
  Breadcrumbs,
  Button,
  CardMedia,
  Checkbox,
  Chip,
  Collapse,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
  Divider,
  Drawer,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  Link,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuProps,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
  SxProps
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import React, {
  Fragment,
  MutableRefObject,
  useEffect,
  useState,
  Dispatch,
  SetStateAction,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import { logout } from '../redux-store/actions/auth';
import { MobileProfileIcon, ProfileIcon } from './customSVGs';
import { ArrowDropDown, Close, MoreVert, Search } from '@mui/icons-material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Field, Form, Formik, useFormikContext } from 'formik';
import { useHistory } from 'react-router';
import * as yup from 'yup';
import { MFTextField } from '../lib/formik';
import MFCheckbox from '../lib/formik/Checkbox';
import { SearchFieldWrapper, renderFilteredOptions } from '../lib/formik/searchSelectField';
import { RootStateType } from '../redux-store/reducers';
import { Applicant, Bank, NomineeType } from '../redux-store/types/api-types';
import { APPLICATION_TYPE, USER_ROLES } from '../utils/constant';
import { copyGraphToClipboard, getCountryCodes, getNotificationCategory, isModuleAllowed } from '../utils/utilityFunctions';
import { Item, ItemDetails } from './ApplicationDetails';
import { KeyValue } from './ApplicationDetails/personalDetails';
import { SubHeading } from './investors/components';
import { useSnackbar } from 'notistack';
import { SET_VALUE } from '../redux-store/types/valueConverter';
import DropdownIcon from '../assets/icons/DropdownIcon';
import { CartIcon, HamburgerCLIcon, MobileCartIcon, MobileNotificationIcon, NotificationsIcon, WarningIcon, InfoIconOutlined } from '../assets/SvgIcons';
import dayjs from 'dayjs';
import getSideBarData from './sideBarData';
import { LOGOUT_SUCCESS } from '../redux-store/types/auth';
import { formatTimeStamp } from './Notifications/Notifications';
// import { BottomDisclaimer } from './ApplicationDetails/TermsAndConditions';

export function OtpTimer({ onResend, numberOfOTPTries }: { onResend: () => void; numberOfOTPTries: number }): JSX.Element {
  const [counter, setCounter] = useState(60);

  // Third Attempts
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const timer: any = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  return (
    // <Box>
    //   <Typography>
    //     <Button
    //       sx={{
    //         color: 'primary.main',
    //         mt: 2,
    //         fontSize: 16,
    //         fontWeight: 500,
    //         p: 0,
    //         ':hover': {
    //           background: 'none',
    //         },
    //       }}
    //       disabled={counter > 0}
    //       onClick={() => {
    //         try {
    //           onResend();
    //           setCounter(60);
    //         } catch (e) {
    //           console.error((e as Error).message);
    //         }
    //       }}>
    //       Didn’t receive OTP? Resend OTP
    //     </Button>
    //     <br />
    //     {counter > 0 && `in ${counter} seconds`}
    //   </Typography>
    // </Box>
    <Grid container justifyContent="center" sx={{ mt: 2, mb: 2 }}>
      {numberOfOTPTries >= 3 ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            mt: 1
          }}
        >
          <Typography
            variant='body_400'
            color="text.secondary"
          >
            Resend OTP limits exhausted please try resending after 1 hour
          </Typography>
        </Box>
      ) : (
        <>
          <Grid item xs={12}>
            <Typography variant='body_400' color="text.secondary" align="center">
              Didn&apos;t receive OTP?{' '}
              <Typography
                component="span"
                variant='body_400'
                sx={{
                  cursor: counter > 0 ? "not-allowed" : "pointer",
                  fontWeight: counter === 0 ? 500 : 400
                }}
                color={counter > 0 ? "text.secondary" : "primary.500"}
                onClick={() => {
                  try {
                    if (counter === 0) {
                      onResend();
                      setCounter(60);
                    }
                  } catch (e) {
                    console.error((e as Error).message);
                  }
                }}
              >
                {/* Resend OTP{numberOfOTPTries >= 2 ? ` (Voice)` : ` (SMS)`} */}
                  Resend OTP (SMS)
              </Typography>
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ textAlign: 'center', mt: 1 }}>
            {counter > 0 && (
              <Typography
                variant='body_400'
                color="text.secondary"
                sx={{ fontSize: '0.875rem' }}
              >
                Resend in {counter} seconds
              </Typography>
            )}
          </Grid>
        </>
      )}
    </Grid>
  );
}

// Footer
export const Footer = (): JSX.Element => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        display: 'flex',
        justifyContent: 'center',
        py: 1,
      }}>
      <Typography sx={{ color: 'common.white', width: 'unset', mr: '0.5rem' }}>
        Powered By{' '}
      </Typography>
      <CardMedia
        component="img"
        src="/images/kfin-new-logo.png"
        alt="kFintech Logo"
        sx={{ width: 'unset' }}
      />
    </Box>
  );
};
// Footer End

// Login Layout
export const LoginLayout = ({
  LoginText,
  children,
  renderChildUI
}: {
  LoginText: string;
  children: JSX.Element;
  renderChildUI?: boolean
}): JSX.Element => {
  const history = useHistory();
  return (
    <Stack
      sx={{
        minHeight: '100vh',
        background: '#f2f6f8 url("/images/abcl-newbg.svg")',
        backgroundSize: 'cover',
      }}>
      <AppBar elevation={0} position="static" sx={{ bgcolor: 'transparent', height: { xs: '70px', sm: '80px', md: '100px', lg: '120px' } }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            height: '100%',
          }}
        >
          <Box
            onClick={() => history.push('/')}
            sx={{
              width: "12rem",
              height: '100%',
              margin: "5px 0px 0px 15px",
              cursor: 'pointer',
              backgroundImage: 'url("/images/abcl-wealth-logo.svg")',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'left',
            }}
            role="img"
            aria-label="Logo"
          />
        </Box>
      </AppBar>
      <Box
        component="main"
        sx={{
          flex: 1,
          display: 'grid',
          placeItems: 'center',
        }}>
        {renderChildUI && (
          <>
            {children}
          </>
        )}
        {!renderChildUI && (
          <Box
            sx={{
              bgcolor: 'grey.50',
              height: { xs: 'unset', sm: 'unset' },
              width: 'clamp(300px, 70%, 500px)',
              px: { xs: '25px', sm: '80px' },
              py: '50px',
              mb: 2,
              borderRadius: '10px',
              boxShadow: '0px 3.29214px 6.58427px rgba(27, 27, 27, 0.16)',
            }}>
            <Typography
              component="h1"
              variant="h1"
              sx={{
                color: 'primary.main',
                mb: '50px',
                textAlign: 'center',
              }}>
              {LoginText}
            </Typography>
            {children}
          </Box>
        )}
      </Box>
      <Footer />
    </Stack>
  );
};
// Login Layout End

// Header & Sidenav
const drawerWidth = '16.87rem';

const MenuButton = ({
  isActive = false,
  to = null,
  text,
  onClick,
}: {
  isActive?: boolean;
  to?: string | null;
  text?: string;
  children?: JSX.Element;
  downArrow?: boolean;
  onClick?: () => void;
}) => {
  const disabled = to === null;
  return (
    <ListItemButton
      onClick={onClick}
      component={disabled ? Typography : RouterLink}
      to={to || ''}
      sx={{
        p: { xs: '10px 20px', md: '12px 15px' },
        background: isActive ? 'rgba(30, 144, 255, 1)' : 'transparent',
        color: isActive ? 'rgba(237, 242, 247, 1)' : 'secondary.main',
        stroke: isActive ? '#2057A6' : '#131836',
        strokeWidth: 0,
        height: '54px',
        '.MuiSvgIcon-root ': {
          opacity: isActive ? 1 : 0.5,
        },
        textAlign: 'center',
        borderRadius: '15px',
      }}>
      <Typography
        sx={{ color: isActive ? 'rgba(237, 242, 247, 1)' : 'text.primary', fontWeight: '600' }}
        variant="subtitle_400">
        {text}
      </Typography>
    </ListItemButton>
  );
};

const dashboardLinks = [
  { label: 'Home', link: '/dashboard' },
  { label: 'Clients', link: '/investors' },
  { label: 'Net Sales', link: '/net-sales' },
  { label: 'Total RMs', link: '/total-rm-detail' },
];

const productsLinks = [
  { label: 'Mutual Funds', link: '/product' },
  { label: 'Direct Equity', link: '/product/direct-equity' },
  { label: 'PMS', link: '/product/pms' },
  { label: 'Debt', link: '/product/debt' },
  { label: 'Alternates', link: '/product/alternates' },
  { label: 'Insurance', link: '/product/insurance' },
];

const analyticsLinks = [
  // { label: 'Mutual Fund Research', link: '/analytics/mutual-fund-research' },
  { label: 'Portfolio Analytics', link: '/analytics/portfolio-analytics' },
  // { label: 'Revenue Analytics', link: '/analytics/revenue-analytics' },
];

const applicationLinks = [
  // { label: 'Add New', link: '/onboarding' },
  { label: 'Create Onboarding', link: '/onboarding' },
  // { label: 'View Existing', link: '/applications' },
  // { label: 'View Email Consent', link: '/view-consent-email-list' },
  { label: 'Onboarding Status', link: '/applications' },
  { label: 'Re-KYC Status', link: '/re-kyc-status' },
  // { label: 'Onboarding DashBoard', link: '/onboard-overview' },
  { label: 'Non MF Product Applications', link: '/non-mf-applications' },

]

const ordersLinks = [
  { label: 'Order Dashboard', link: '/orders/order-dashboard' },
  { label: 'Order Entry', link: '/orders/order-entry' }
]

const creationAccountLinks = [
  { label: 'Create Joint Account', link: '/create-account' },
  { label: 'Joint Account Status', link: '/account-status' }
]

export const FilterDrawer = ({
  selectedFilters,
  setSelectedFilters,
  ...rest
}: MenuProps & {
  selectedFilters: {
    [key: string]: string[];
  };
  setSelectedFilters: React.Dispatch<React.SetStateAction<{ [key: string]: string[] }>>;
}): JSX.Element => {
  const [selectedFilterSection, setSelectedFilterSection] = useState<number | string>(-1);
  const [selectedLocalFilters, setSelectedLocalFilters] = useState<{ [key: string]: string[] }>(
    selectedFilters
  );
  const [search, setSearch] = useState<string>('');
  const { filters: totalFilters } = useSelector((state: RootStateType) => state.products);
  const filters = totalFilters
    .filter((each) => {
      const children = each.options.filter((option) => {
        return option && typeof option === 'object'
          ? option.label.toLowerCase().includes(search.toLowerCase())
          : option && option.toLowerCase().includes(search.toLowerCase());
      });
      return children.length > 0;
    })
    .map((each) => {
      return {
        ...each,
        options: each.options.filter((option) =>
          option && typeof option === 'object'
            ? option.label.toLowerCase().includes(search.toLowerCase())
            : option && option.toLowerCase().includes(search.toLowerCase())
        ),
      };
    });

  useEffect(() => {
    setSelectedLocalFilters(selectedFilters);
  }, [selectedFilters]);
  return (
    <Menu
      {...rest}
      transformOrigin={{ horizontal: 'center', vertical: 'top' }}
      PaperProps={{ sx: { maxWidth: '400px' } }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', p: 2, gap: 4 }}>
        <Input
          placeholder="Search"
          fullWidth
          endAdornment={<Search />}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <IconButton onClick={(e) => rest?.onClose && rest?.onClose(e, 'backdropClick')}>
          <Close />
        </IconButton>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, p: 2 }}>
        {filters.map(
          (
            {
              title,
              key,
              options,
            }: {
              title: string;
              key: string;
              options: ({ label: string; value: string } | string)[];
            },
            index: number
          ) => (
            <Box key={`${title}_${index}`} sx={{ width: '100%' }}>
              <Box>
                <Box
                  onClick={() => {
                    setSelectedFilterSection(selectedFilterSection === key ? -1 : key);
                  }}
                  sx={{
                    width: '100%',
                    gap: 3,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                  }}>
                  <Typography>{title}</Typography>
                  <ArrowDropDown sx={{ color: '#337FC9' }} />
                </Box>
                <Divider />
              </Box>
              {selectedFilterSection === key && (
                <Box
                  sx={{
                    pt: 1,
                    px: 2,
                    maxHeight: '150px',
                    transition: '0.3s all',
                    overflow: 'auto',
                  }}>
                  <FormGroup>
                    {options.map(
                      (option: { label: string; value: string } | string, index: number) => {
                        let label = '',
                          value = '';
                        if (option && typeof option === 'object') {
                          label = option.label;
                          value = option.value;
                        } else if (option) {
                          label = option;
                          value = option;
                        }

                        return label && value ? (
                          <Fragment key={`${value}_${index}`}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    selectedLocalFilters?.[key]
                                      ? selectedLocalFilters?.[key].includes(value)
                                      : false
                                  }
                                  onChange={(e) => {
                                    const updatedFilters = { ...selectedLocalFilters };
                                    const { checked } = e.target;
                                    if (updatedFilters[key]) {
                                      if (checked) {
                                        const values = [...updatedFilters[key]];
                                        if (!values.includes(value)) {
                                          values.push(value);
                                        }
                                        updatedFilters[key] = values;
                                      } else {
                                        updatedFilters[key] = updatedFilters[key].filter(
                                          (val) => val !== value
                                        );
                                      }
                                    } else if (checked) {
                                      updatedFilters[key] = [value];
                                    }
                                    setSelectedLocalFilters(updatedFilters);
                                  }}
                                  checkedIcon={
                                    <Box
                                      sx={{
                                        border: '2px solid #22242C',
                                        margin: '2px',
                                        borderRadius: '2px',
                                        backgroundColor: '#337FC9',
                                        '&:before': {
                                          display: 'block',
                                          width: 16,
                                          height: 16,
                                          content: '""',
                                        },
                                      }}></Box>
                                  }
                                />
                              }
                              label={label}
                            />
                            <Divider />
                          </Fragment>
                        ) : null;
                      }
                    )}
                  </FormGroup>
                </Box>
              )}
            </Box>
          )
        )}
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 3 }}>
          <Button
            onClick={(e) => {
              setSelectedFilters(selectedLocalFilters);
              rest?.onClose && rest?.onClose(e, 'backdropClick');
            }}
            sx={{
              bgcolor: '#337FC9',
              borderRadius: '5px',
              fontWeight: 'normal',
              padding: 0,
              px: 1,
              '&:hover': { bgcolor: '#2868a6' },
            }}>
            Apply
          </Button>
          <Button
            onClick={(e) => {
              setSelectedFilters({});
              rest?.onClose && rest?.onClose(e, 'backdropClick');
            }}
            sx={{
              border: '1px solid #337FC9',
              borderRadius: '5px',
              padding: 0,
              px: 1,
              color: '#337FC9',
              fontWeight: 'normal',
              '&:hover': {
                bgcolor: '#eaf0f5',
              },
            }}>
            Clear All
          </Button>
        </Box>
      </Box>
    </Menu>
  );
};

export const Header = ({ handleDrawerToggle }: { handleDrawerToggle: () => void }): JSX.Element => {
  const theme = useTheme();
  const { role, permissions = [] } = useSelector((store: RootStateType) => store.auth);
  const { cartItemsCount = 0 } = useSelector((store: RootStateType) => store.cart);
  const { rmName = "", businessDate = "", company = "", environment = "", userRole = "" } = useSelector((store: RootStateType) => store.navbarInfo);

  const formattedBusinessDate = businessDate ? dayjs(businessDate, 'DD/MM/YYYY').format('DD MMM, YYYY') : ""

  const dispatch = useDispatch();
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [menuAnchorEl2, setMenuAnchorEl2] = useState<null | HTMLElement>(null);
  const [isLogout, setIsLogout] = useState<boolean>(false);
  const menuOpen = Boolean(menuAnchorEl);
  const menuOpen2 = Boolean(menuAnchorEl2);
  const { palette } = useTheme();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const { notifications = [] } = useSelector((store: RootStateType) => store.navbarInfo);
  const history = useHistory()

  const handleProfileLogout = async () => {
    // dispatch(setCartItemsCount(0));
    setIsLogout(true);
    await dispatch(logout());
    history.push('/login');
  }

  const handleCartIconClick = () => {
    if (location.pathname !== '/cart') {
      history.push("/cart")
    }
  }

  const handleNotificationClick = () => {
    history.push("/notifications");
    setMenuAnchorEl2(null);
  }

  return (
    <>
      <Box
        sx={(theme: Theme) => ({
          display: 'flex',
          // justifyContent: { xs: 'space-between', md: 'flex-end' },
          justifyContent: { xs: 'space-between' },
          alignItems: 'center',
          // padding: { xs: '25px 20px 20px', md: '20px 25px 0px 25px' },
          padding: { xs: '15px 20px 20px' },
          mb: { xs: '5px' },
          // backgroundColor: 'rgba(247, 247, 247, 1)',
          // backgroundColor: { xs: theme.palette.common.white, md: 'rgba(247, 247, 247, 1)' },
          // backgroundColor: { xs: theme.palette.common.white },
          [theme.breakpoints.up(1400)]: {
            // backgroundColor: theme.palette.background.default,
            justifyContent: 'flex-end',
            padding: '20px 25px 0px 25px'
          },
        })}>
        {/* <Box
          sx={{
            minWidth: '300px',
            borderRadius: '57px',
            height: '47.17px',
            border: '1px solid #6C737F',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            padding: '16.25px 17.5px 16.25px 17px',
            cursor: 'pointer',
          }}>
          <SearchIcon />
          <Typography
            sx={{
              color: 'text.secondary',
              paddingLeft: '10px',
              paddingTop: '2px',
              paddingBottom: '2px',
            }}
            variant="subtitle_400">
            Search
          </Typography>
        </Box> */}
        {/* <CardMedia
          component="img"
          onClick={() => history.push('/')}
          // src="/images/kfintechHeaderImg.svg"
          src="/images/abcl-wealth-logo.svg"
          alt="Logo"
          sx={{
            // width: '15rem',
            // width: '12rem',
            width: '9rem',
            // marginBottom: '35px',
            display: {
              xs: 'block',
              // margin: "35px 15px 30px 30px",
              margin: "10px 15px 5px 30px",
              cursor: 'pointer',
              // margin: "35px 15px 30px 15px"
            },
          }}
        /> */}
        <Box sx={{
          display: { xs: 'flex', },
          // display: { xs: 'flex', md: 'none' }, 
          [theme.breakpoints.up(1400)]: {
            display: "none"
          },
          alignItems: 'center',
          columnGap: '0.6rem',
        }}>
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={(theme: Theme) => ({
              // display: { md: 'none' },
              [theme.breakpoints.up(1400)]: {
                display: "none"
              },
              color: 'text.primary'
            })}>
            <HamburgerCLIcon />
          </IconButton>
          <Box
            onClick={() => history.push("/")}
            sx={{
              width: { xs: '5rem', md: '9rem' },
              height: '30px',
              marginTop: '5px',
              // height: { xs: '70px', sm: '80px', md: '100px', lg: '120px' },
              cursor: 'pointer',
              backgroundImage: 'url("/images/abcl-wealth-logo.svg")',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'flex-start',
            }}
            role="img"
            aria-label="Logo"
          />
        </Box>
        <Box
          sx={{
            display: { xs: "flex" },
            columnGap: { xs: "0.5rem", md: "1rem" }
          }}
        >
          {(rmName || formattedBusinessDate || company) && (
            <Box
              display={{ xs: "none", md: "flex" }}
              sx={(theme: Theme) => ({
                columnGap: "1rem",
                alignItems: "center",
                boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                backgroundColor: theme.palette.common.white,
                padding: '5px 8px',
                borderRadius: '15px'
              })}
            >
              {rmName && (
                <Typography
                  variant='body_600'
                  sx={(theme: Theme) => ({ color: theme.palette.primary[500] })}
                >
                  {`${rmName} (${userRole})`}
                </Typography>

              )}
              {formattedBusinessDate && (
                <Typography
                  variant='body_600'
                  sx={(theme: Theme) => ({ color: theme.palette.primary[500] })}
                >
                  System Date: {formattedBusinessDate}
                </Typography>
              )}
              {/* {company && (
                <Typography
                  variant='body_600'
                  sx={(theme: Theme) => ({ color: theme.palette.primary[500] })}
                >
                  Company: {company}
                </Typography>
              )}

              {environment && (
                <Typography
                  variant='body_600'
                  sx={(theme: Theme) => ({ color: theme.palette.primary[500] })}
                >
                  Environment: {environment}
                </Typography>
              )} */}
            </Box>
          )}

          {([USER_ROLES.INVESTOR, USER_ROLES.RM].includes(role)) && <Box sx={{
            display: { xs: 'flex' },
            alignItems: 'center',
          }}>
            <IconButton
              onClick={(e) => setMenuAnchorEl2(e.currentTarget)}
              sx={{
                padding: 0
              }}
            >
              <Badge
                invisible={notifications.length === 0}
                // badgeContent={notifications.length}
                sx={(theme: Theme) => ({
                  '& .MuiBadge-badge': {
                    right: 1,
                    top: 10,
                    backgroundColor: theme.palette.primary[500],
                    color: theme.palette.common.white,
                    ...theme.typography.subtitle_600
                  },
                })}
              >
                {isMobile ? <MobileNotificationIcon isActive={notifications.length > 0} /> : <NotificationsIcon isActive={notifications.length > 0} />}
              </Badge>
            </IconButton>
          </Box>}

          <Box sx={{
            display: { xs: 'flex' },
            alignItems: 'center',
          }}>
            {(
              [USER_ROLES.INVESTOR].includes(role) &&
              isModuleAllowed({ value: "MFOrders", compareArr: permissions, objKey: "permissonCode" })
            ) && (
                <IconButton onClick={handleCartIconClick}
                >
                  <Badge
                    invisible={cartItemsCount === 0}
                    badgeContent={cartItemsCount}
                    sx={(theme: Theme) => ({
                      '& .MuiBadge-badge': {
                        right: 5,
                        top: 10,
                        backgroundColor: theme.palette.primary[500],
                        color: theme.palette.common.white,
                        ...theme.typography.subtitle_600
                      },
                    })}
                  >
                    {isMobile ? <MobileCartIcon /> : <CartIcon />}
                  </Badge>
                </IconButton>
              )}
            <IconButton
              sx={{ padding: 0, ml: 1.5 }}
              onClick={(e) => setMenuAnchorEl(e.currentTarget)}
            >
              {isMobile ? <MobileProfileIcon /> : <ProfileIcon />}
            </IconButton>

          </Box>
        </Box>

      </Box >

      <Menu
        anchorEl={menuAnchorEl}
        open={menuOpen}
        onClose={() => setMenuAnchorEl(null)}
        MenuListProps={{
          'aria-labelledby': 'logout-button',
          sx: {
            padding: "8px 0px",

          }
        }}
        slotProps={{
          paper: {
            sx: {
              width: { xs: '150px', md: '200px' },
              borderRadius: "12px",
              backgroundColor: palette.common.white,
            }
          }
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}

      >
        <MenuItem
          onClick={() => {
            handleProfileLogout()
          }}
          disabled={isLogout}
        >
          {isLogout ? 'Logging out...' : 'Logout'}
        </MenuItem>
      </Menu >

      <Menu
        anchorEl={menuAnchorEl2}
        open={menuOpen2}
        onClose={() => setMenuAnchorEl2(null)}
        MenuListProps={{
          "aria-labelledby": "notifications-menu",
          sx: { padding: 0 },
        }}
        slotProps={{
          paper: {
            sx: {
              width: { xs: "300px", md: "500px" },
              borderRadius: "12px",
              backgroundColor: "white",
              maxHeight: "600px",
              display: "flex",
              flexDirection: "column",
            },
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {/* ---- Sticky Header ---- */}
        <Box
          p={1}
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 2,
            backgroundColor: "white",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Typography variant="body_500" fontWeight="bold">
            Notifications
          </Typography>
        </Box>

        {/* ---- Scrollable Body ---- */}
        <Box
          sx={{
            overflowY: "auto",
            flex: 1,
            px: 1,
            py: 1,
          }}
        >
          {notifications.length === 0 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Typography variant="body2" color="text.secondary">
                No notifications
              </Typography>
            </Box>
          )}
          {notifications.length !== 0 && notifications.map((item, index) => {
            const formatDate = (dateStr: any) => {
              if (!dateStr || dateStr === "19700101") return "N/A";
              const date = dateStr.includes("-")
                ? new Date(dateStr)
                : new Date(
                  dateStr.slice(0, 4),
                  dateStr.slice(4, 6) - 1,
                  dateStr.slice(6, 8)
                );
              return date.toLocaleDateString("en-IN", {
                year: "numeric",
                month: "short",
                day: "numeric",
              });
            };

            const chipColor =
              item.notificationType === "FATAL"
                ? "error"
                : item.notificationType === "ALERT"
                  ? "warning"
                  : item.notificationType === "01" ? "success" : item.notificationType === "03" ? "warning" : "default";

            return (
              <Box key={index} px={1} py={0.5}>
                <Box
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    p: 1,
                    backgroundColor: "#fff",
                    boxShadow: "0px 1px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  {/* Header */}
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  // mb={1}
                  >
                    <Typography fontWeight={600} color="primary.main" variant='body_500'>
                      {item?.notificationHeader || "No title available"}
                    </Typography>
                    <Chip
                      label={getNotificationCategory(item.notificationType)}
                      color={chipColor}
                      size="small"
                      sx={{ fontSize: "0.55rem", fontWeight: "bold" }}
                    />
                  </Stack>

                  {/* Message */}
                  <Typography
                    variant="subtitle_600"
                    sx={{ mb: 1, fontStyle: "italic", color: "text.secondary" }}
                  >
                    {item.notificationSubHeader}
                  </Typography>

                  {/* Info Section */}
                  <Stack
                    direction={{ xs: "column", md: "row" }}
                    justifyContent="space-between"
                    spacing={1}
                  >
                    <Typography variant="overline_400" sx={{ display: 'flex', flexDirection: { xs: 'row', md: 'column' }, gap: { xs: 1, md: 0 } }}>
                      <strong>UCC Code:</strong> {item.clientCode}
                    </Typography>

                    <Typography variant="overline_400" sx={{ display: 'flex', flexDirection: { xs: 'row', md: 'column' }, gap: { xs: 1, md: 0 } }}>
                      <strong>Investor Name:</strong> {item.clientName}
                    </Typography>

                    <Typography variant="overline_400" sx={{ display: 'flex', flexDirection: { xs: 'row', md: 'column' }, gap: { xs: 1, md: 0 } }}>
                      <strong>Trade Restriction:</strong>{" "}
                      {item.tradeRestriction ?? "-"}
                    </Typography>

                    <Typography variant="overline_400" sx={{ display: 'flex', flexDirection: { xs: 'row', md: 'column' }, gap: { xs: 1, md: 0 } }}>
                      <strong>Next Re-KYC Date:</strong>{" "}
                      {formatDate(item.nextRekycDate) ?? "-"}
                    </Typography>

                    {/* <Typography variant="body2" sx={{ display: 'flex', flexDirection: { xs: 'row', md: 'column' }, gap: { xs: 1, md: 0 } }}>
                      <strong>Notification Date:</strong>{" "}
                      {formatTimeStamp(item.notificationTimestamp) ?? "-"}
                    </Typography> */}
                  </Stack>

                  {/* Footer */}
                  {/* <Typography
                    variant="caption"
                    display="block"
                    sx={{ mt: 0.5, color: "text.disabled", textAlign: "right" }}
                  >
                    Business Date: {formatDate(item.businessDate)}
                  </Typography> */}
                </Box>
              </Box>
            );
          })}
        </Box>

        {notifications.length !== 0 && <Box
          sx={{
            position: "sticky",
            bottom: 0,
            zIndex: 2,
            backgroundColor: "white",
            borderTop: "1px solid #e0e0e0",
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            px: 2,
            py: 1,
          }}
        >
          <Button
            sx={{
              color: "text.secondary",
              backgroundColor: "transparent",
              borderColor: "text.secondary",
              borderWidth: "0.5px",
              borderStyle: "solid",
              padding: "15px 15px",
              height: "30px",
              ...theme.typography.overline_400,
              "&:hover": {
                borderColor: "text.secondary",
                backgroundColor: "background.default",
              },
            }}
            onClick={() => setMenuAnchorEl2(null)}
            color="inherit"
          >
            Cancel
          </Button>
          <Button
            sx={{
              color: "primary.200",
              backgroundColor: "primary.50",
              borderColor: "primary.200",
              borderWidth: "0.5px",
              padding: "15px 15px",
              height: "30px",
              borderStyle: "solid",
              ...theme.typography.overline_400,
              "&:hover": { backgroundColor: "background.default" },
            }}
            variant="outlined"
            onClick={() => handleNotificationClick()}
          >
            View All
          </Button>
        </Box>}
      </Menu>
    </>
  );
};

const PostLoginFooter = ({ isMobileDrawerOpen }: { isMobileDrawerOpen: boolean }) => {
  return (
    <Box
      component="footer"
      sx={(theme: Theme) => ({
        backgroundColor: theme.palette.primary[500],
        height: "40px",
        py: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: "center",
        zIndex: isMobileDrawerOpen ? 1100 : 1200,
        position: "absolute",
        bottom: 0,
        width: "100%"
      })}
    >
      <Typography
        variant='body_500'
        sx={(theme: Theme) => ({
          color: theme.palette.common.white,
          selfAlign: "center"
        })}
      >
        Disclaimer
      </Typography>
    </Box>
  )
}

export const ConfirmationDialog = ({
  open,
  setOpen,
  message = 'Are you sure you want to delete?',
  subMessage = "",
  onCancel,
  onSave,
  showIcon = false,
  icon,
  primaryButtonText = 'Yes',
  secondaryButtonText = "No",
  customWidth = ''
}: {
  message: string | JSX.Element;
  subMessage?: string | JSX.Element;
  open: boolean;
  setOpen: () => void;
  onCancel: () => void;
  onSave: () => void;
  showIcon?: boolean;
  icon?: JSX.Element;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  customWidth?: string
}): JSX.Element => {
  return (
    // <Dialog open={open} onClose={setOpen}>
    //   <Box
    //     sx={{
    //       p: { xs: 2, sm: '45px 40px' },
    //       borderRadius: '10px',
    //       // width: { xs: '70%', sm: '70%' },
    //       maxWidth: 400,
    //       height: { xs: '90%', md: 'unset' },
    //       overflowY: 'auto',
    //     }}>
    //     <Box
    //       sx={{
    //         display: 'flex',
    //         flexDirection: 'column',
    //         alignItems: 'center',
    //         justifyContent: 'center',
    //         '& .MuiButton-root': {
    //           minWidth: 100,
    //           fontSize: 16,
    //         },
    //       }}>
    //       <Typography
    //         sx={{
    //           fontSize: 20,
    //           fontWeight: 500,
    //           color: '#337FC9',
    //           textAlign: 'center',
    //           mb: 5,
    //         }}>
    //         {message}
    //       </Typography>
    //       <Box
    //         sx={{
    //           display: 'flex',
    //           gap: 1.5,
    //           '.MuiButton-root': {
    //             minWidth: '100px',
    //           },
    //         }}>
    //         <Button variant="contained" onClick={onSave} sx={{ color: 'common.white' }}>
    //           Yes
    //         </Button>
    //         <Button variant="outlined" onClick={onCancel} sx={{ color: 'primary.main' }}>
    //           No
    //         </Button>
    //       </Box>
    //     </Box>
    //   </Box>
    // </Dialog>
    <Dialog
      onClose={setOpen}
      open={open}
      maxWidth='sm'
      fullWidth
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '15px',
          backgroundColor: "background.paper",
          rowGap: "5px",
        },
      }}
    >
      <DialogContent sx={{ paddingTop: "25px" }}>
        <Box sx={{ display: "flex", columnGap: "8px" }}>
          {showIcon ? icon || <WarningIcon /> : null}
          <Typography variant='h2' color="text.primary" mb="10px">{message}</Typography>
        </Box>
        {subMessage &&
          <Typography
            variant='subtitle_400'
            color="text.secondary"
            sx={{
              lineHeight: "20px",
              maxHeight: '400px',
              overflowY: 'auto',
            }}
          >
            {subMessage}
          </Typography>
        }
      </DialogContent>
      <DialogActions sx={{ padding: "25px", columnGap: "10px" }}>
        <Button
          variant="outlined"
          onClick={onCancel}
          sx={(theme: Theme) => ({
            color: theme.palette.text.secondary,
            flex: 1,
            border: `0.5px solid ${theme.palette.text.secondary}`,
            padding: "10px",
            "&:hover, &.Mui-focusVisible": {
              borderColor: theme.palette.text.secondary,
              backgroundColor: theme.palette.background.default
            }
          })}
        >
          {secondaryButtonText}
        </Button>
        <Button
          variant="contained"
          sx={(theme: Theme) => ({
            flex: 1,
            color: theme.palette.textDark.primary,
            padding: "10px"
          })}
          onClick={onSave}
        >
          {primaryButtonText}
        </Button>
      </DialogActions>
    </Dialog >
  );
};

type Props = DialogProps & {
  title?: string;
  content: string;
  actions: {
    label: string;
    onClick: () => void;
  }[];
};

export default function SimpleDialog({ title, ...props }: Props): JSX.Element {
  return (
    <Dialog
      {...props}
      sx={{
        '& .MuiPaper-root': {
          minWidth: { sx: '300px', md: '400px' },
          maxWidth: { sx: '500px', md: '500px' },
          borderRadius: '8px',
          padding: '30px 30px 20px',
          textAlign: 'center',
          // color: '#4f4f4f',
        },
        '& .MuiDialogContent-root': {
          textAlign: 'center',
        },
        '& .MuiDialogActions-root': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiButton-root': {
            width: '160px',
            height: '58px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '18px',
            margin: 'auto',
            marginBottom: '20px',
          },
        },
      }}>
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText>{props.content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {props.actions.map((action, index) => (
          <Button variant="contained" color="primary" key={index} onClick={action.onClick}>
            {action.label}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
}

export function CountryCodesDropDown({
  name,
  value,
  readOnly = false,
  disabled = false,
  ElementWidth,
}: {
  name: string;
  value: string;
  readOnly?: boolean;
  disabled?: boolean;
  ElementWidth?: number | null;
}): JSX.Element {
  const { setFieldValue } = useFormikContext();
  const [query, setQuery] = useState('');

  const theme = useTheme()

  return (
    <InputAdornment
      position="start"
      sx={{
        pr: '0 !important',
        mx: '0 !important',
      }}>
      <Box
        sx={{
          '.MuiOutlinedInput-root': {
            marginTop: '0',
            '&.MuiInputBase-root': {
              '& .MuiSelect-select': {
                // padding: '12px 15px 12px 0',
                padding: '0',
                border: 'none',
                '& .MuiBox-root': {
                  columnGap: "5px",
                  alignItems: "center"
                }
              },
            },
            '.MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
          },

          '&.Mui-focused,&:hover': {
            '.MuiOutlinedInput-notchedOutline': {
              borderWidth: 'none',
            },
          },
          // svg: {
          //   color: '#337FC9',
          // },
        }}
      >
        <Select
          labelId="user-items"
          onChange={(e) => {
            setFieldValue(name, `${e.target.value}`);
          }}
          value={value}
          renderValue={(value) => {
            return (
              <Box sx={{ pr: "15px", mr: "15px", display: "flex", justifyContent: "center", borderRightWidth: "1.3px", borderRightStyle: "solid", borderRightColor: "text.secondary" }}>
                <Typography variant='body_500' color="text.primary">{value.split(':')[1] ? value.split(':')[1].trim() : value}</Typography>
                <DropdownIcon strokeColor={theme.palette.text.secondary} />
              </Box>
            );
          }}
          IconComponent={() => null}
          MenuProps={{
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            sx: {
              '.MuiPaper-root ': {
                width: ElementWidth,
                ml: '-10px',
                maxHeight: '20%',
                overflowX: 'auto',
              },
            },
            disableAutoFocusItem: true,
            MenuListProps: {
              disableListWrap: true,
            },
          }}
          onClose={() => {
            setQuery('');
          }}
          readOnly={readOnly}
          disabled={disabled}
        >
          <SearchFieldWrapper searchFieldPlaceholder={'Search...'} setQuery={setQuery} />
          {renderFilteredOptions(
            getCountryCodes().map((codes) => ({
              key: codes.label,
              value: codes.label,
            })),
            query
          )}
          {/* {getCountryCodes().map((codes, ind) => (
            <MenuItem value={codes.label} key={ind}>
              {codes.label}
            </MenuItem>
          ))} */}
        </Select>
      </Box>
    </InputAdornment >
  );
}
export interface AmlPopupValues {
  amlComments: string;
  amlAcknowledgement: boolean;
}

const amlPopupInitialValues: AmlPopupValues = {
  amlComments: '',
  amlAcknowledgement: false,
};
const amlPopupValidation = yup.object().shape({
  amlComments: yup.string().required('Field is required'),
  amlAcknowledgement: yup.bool().test('amlAcknowledgement', 'Field is required', (value) => {
    return value || false;
  }),
});
export function AmlPopup({
  handleClose,
  amlPopupOpen,
  onSubmit,
  FURTHER_INFORMATION,
  EXTERNAL_SOURCES,
  displayDocInfo = false,
}: {
  handleClose: () => void;
  amlPopupOpen: boolean;
  onSubmit: (values: AmlPopupValues) => void;
  FURTHER_INFORMATION?: string;
  EXTERNAL_SOURCES?: string;
  displayDocInfo?: boolean;
}): JSX.Element {
  return (
    <Dialog
      onClose={handleClose}
      open={amlPopupOpen}
      sx={{
        '.MuiPaper-root ': {
          p: 2,
          width: { xs: '100%', sm: '70%' },
        },
      }}>
      <Box sx={{ mb: 2, mt: 1 }}>
        <CardMedia
          component="img"
          src="/images/warning-icon-red.svg"
          sx={{ width: '50px', mx: 'auto' }}
        />
      </Box>
      <Box
        sx={{
          width: { xs: '100%', sm: '89%' },
          mx: 'auto',
        }}>
        <Typography
          sx={{
            color: '#BD2932',
            textAlign: 'center',
            mb: 1,
            fontSize: 14,
            fontWeight: 500,
          }}>
          Sorry, this PAN has failed the AML check
        </Typography>
        <Typography
          sx={{
            color: 'secondary.main',
            textAlign: 'start',
            mt: 2,
            fontSize: 16,
            fontWeight: 500,
            mb: 0.5,
          }}>
          Further Information:
        </Typography>
        <Box
          sx={{
            width: '100%',
            height: '25vh',
            overflowY: 'auto',
            overflowWrap: 'anywhere',
            border: '1px solid #ccc',
            borderRadius: '5px',
          }}>
          <Typography
            sx={{
              color: 'rgba(0,0,0,0.7)',
              textAlign: 'start',
              m: 2,
              fontSize: 14,
              fontWeight: 500,
            }}>
            {FURTHER_INFORMATION || ''}
          </Typography>
          <Typography
            sx={{
              color: 'primary.main',
              textAlign: 'start',
              ml: 2,
              fontSize: 16,
              fontWeight: 600,
            }}>
            Reference Links
          </Typography>
          <Typography
            sx={{
              color: 'rgb(0, 0, 255)',
              textAlign: 'start',
              fontSize: 14,
              fontWeight: 500,
              m: 2,
              mt: 0.5,
            }}>
            {EXTERNAL_SOURCES || ''}
          </Typography>
        </Box>
        <Typography
          sx={{
            color: 'secondary.main',
            textAlign: 'start',
            fontSize: 14,
            fontWeight: 500,
            mt: 3,
            mb: 0,
          }}>
          If you still wish to proceed with this PAN, please provide reason below.
        </Typography>
        <Formik
          initialValues={amlPopupInitialValues}
          onSubmit={onSubmit}
          validationSchema={amlPopupValidation}>
          {({ handleSubmit, values }) => (
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)',
                '.MuiTypography-root': {
                  fontSize: 15,
                  fontWeight: 500,
                },
              }}>
              <MFTextField
                name="amlComments"
                multiline
                rows={3}
                inputProps={{
                  maxLength: 1024,
                }}
                placeholder="Type here..."
                displayCharecterCounter={'1024'}
                sx={{
                  color: 'rgba(0,0,0,0.7)',
                  pl: 0.5,
                  pt: 0.5,
                  '&.MuiInputBase-root': {
                    fontSize: 14,
                    fontWeight: 500,
                  },
                }}
              />
              <MFCheckbox
                name={`amlAcknowledgement`}
                label="I understand the risks and acknowledge to proceed further."
                sx={{ mt: 1 }}
              />
              {values.amlAcknowledgement && displayDocInfo && (
                <Typography
                  sx={{
                    color: 'primary.main',
                    textAlign: 'center',
                    fontSize: 14,
                    fontWeight: 500,
                    mt: 1,
                    mb: 0,
                  }}>
                  Please upload compliance document in document details.
                </Typography>
              )}
              <Grid container sx={{ mt: 3, mb: 1, justifyContent: 'center', gap: 1.5 }}>
                <Button
                  onClick={() => {
                    handleClose();
                  }}
                  variant="outlined"
                  sx={{
                    fontSize: 15,
                    color: 'primary.main',
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 500,
                  }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    fontSize: 15,
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 400,
                  }}
                  type="submit">
                  Proceed
                </Button>
              </Grid>
            </Box>
          )}
        </Formik>
      </Box>
    </Dialog>
  );
}
export function AmlDetailsFields({
  amlCheck,
  amlCommentedRole,
  amlComments,
  kraVerified = ''
}: {
  amlCheck: boolean | undefined;
  amlCommentedRole: string | undefined;
  amlComments: string | undefined;
  kraVerified?: string | undefined;
}): JSX.Element {
  return (
    <Grid
      item
      container
      rowSpacing={3}
      pb={2}
      columnSpacing={13}
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      sx={{ paddingLeft: { xs: 0, sm: '10%' } }}>
      {kraVerified && <KeyValue title={'CVL Kra Verified'} description={kraVerified?.toString().toUpperCase() || ''} />}
      {/* <KeyValue title={'AML Check'} description={amlCheck?.toString().toUpperCase() || ''} /> */}
      {/* <KeyValue title={'Commented By'} description={amlCommentedRole?.toUpperCase() || ''} />
      <Grid item xs={12}>
        <Item>{'Comments'}</Item>
        <ItemDetails> {amlComments || '-'}</ItemDetails>
      </Grid> */}
    </Grid>
  );
}
export function AmlDetails({
  applicants = [],
  applicationType,
}: {
  applicants: Partial<Applicant>[];
  applicationType: string;
}): JSX.Element {
  return (
    <>
      {!applicants.every((applicant) => applicant.amlCheck) && (
        <Box
          sx={{
            bgcolor: 'white',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
            borderRadius: '10px',
          }}
          my={5}>
          <Box sx={{ p: 2 }}>
            <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                <Typography sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
                  Aml Check Details
                </Typography>
              </Grid>
              {applicants
                .filter((applicant) => !applicant.amlCheck)
                .map((applicant, index: number) => {
                  const title = [
                    'First Applicant Details',
                    'Second Applicant Details',
                    'Third Applicant Details',
                  ][Number(applicant.applicant_type) - 1];
                  return (
                    <React.Fragment key={applicant.id}>
                      {applicationType !== APPLICATION_TYPE.NON_INDIVIDUAL && (
                        <SubHeading
                          sx={{
                            color: 'common.black',
                            letterSpacing: 0.5 + 'px',
                            padding: { xs: '10px 10px', sm: '10px 30px' },
                          }}>
                          {title}
                        </SubHeading>
                      )}
                      <AmlDetailsFields
                        amlCheck={applicant.amlCheck}
                        amlCommentedRole={applicant.amlCommentedRole}
                        amlComments={applicant.amlComments}
                        kraVerified={applicant.kraVerified}
                      />
                    </React.Fragment>
                  );
                })}
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
}

export const LoadingDialog = ({
  loadingPopup,
  onLoadingPopupClose,
  loaderText = 'Loading',
}: {
  loadingPopup: boolean;
  onLoadingPopupClose: () => void;
  loaderText?: string;
}): JSX.Element => {
  return (
    <Dialog
      onClose={onLoadingPopupClose}
      open={loadingPopup}
      sx={{
        '.MuiPaper-root ': {
          p: 4,
          width: { xs: '70%', sm: '70%' },
        },
      }}>
      <Box
        sx={{
          width: { xs: '100%', sm: '80%' },
          mx: 'auto',
          '.MuiTypography-root': {
            fontSize: 20,
            fontWeight: 500,
          },
        }}>
        <Typography sx={{ color: 'primary.main', lineHeight: '35px', textAlign: 'center' }}>
          {loaderText}...
        </Typography>
      </Box>
    </Dialog>
  );
};
export const CopyGraphDropdown = ({
  elementRef,
}: {
  elementRef: React.MutableRefObject<HTMLElement | null>;
}): JSX.Element => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const { enqueueSnackbar } = useSnackbar();
  const menuOpen = Boolean(menuAnchorEl);

  const handleClose = () => setMenuAnchorEl(null);
  return (
    <>
      <IconButton onClick={(e) => setMenuAnchorEl(e.currentTarget)}>
        <MoreVert />
      </IconButton>

      {/* <Backdrop open={menuOpen} onClick={handleClose} sx={{ zIndex: 1201 }}> */}
      <Menu
        anchorEl={menuAnchorEl}
        transformOrigin={{ horizontal: 'center', vertical: 'top' }}
        open={menuOpen}
        onClose={() => setMenuAnchorEl(null)}
        PaperProps={{ sx: { '.MuiList-root': { padding: 0 } } }}>
        <MenuItem
          onClick={() => {
            handleClose();
            elementRef !== null &&
              copyGraphToClipboard(elementRef as MutableRefObject<HTMLElement>)
                .then(() => {
                  enqueueSnackbar('Graph copied to clipboard successfully.', {
                    variant: 'success',
                    autoHideDuration: 3000,
                  });
                })
                .catch(() => {
                  enqueueSnackbar('Error while copying the graph.', {
                    variant: 'error',
                    autoHideDuration: 3000,
                  });
                });
          }}
          sx={{ padding: '10px 20px' }}>
          Copy
        </MenuItem>
      </Menu>
      {/* </Backdrop> */}
    </>
  );
};

export function PopoverValue({
  label,
  color,
  amount,
  percent,
}: {
  label?: string | null;
  color: string;
  amount?: string | number | null;
  percent?: string | number | null;
}): JSX.Element {
  return (
    <Grid container>
      <Grid item container alignItems={'center'} justifyContent={'center'}>
        <Grid item xs="auto">
          <Typography
            sx={{
              width: '11px',
              height: '11px',
              borderRadius: '50%',
              background: color,
              display: 'inline-block',
              mr: 1,
            }}></Typography>
        </Grid>
        <Grid item xs>
          <Typography sx={{ fontSize: 13, color: '#22242C', opacity: 0.6, mb: 0.5 }}>
            {label}
          </Typography>
        </Grid>
      </Grid>
      <Grid item container>
        <Grid item xs="auto">
          <Typography
            sx={{
              visibility: 'hidden',
              width: '11px',
              height: '11px',
              borderRadius: '50%',
              background: color,
              display: 'inline-block',
              mr: 1,
            }}></Typography>
        </Grid>
        <Grid item xs>
          <Typography
            sx={{
              fontSize: 13,
              color: '#22242C',
              fontWeight: 500,
            }}>
            {amount}
          </Typography>
        </Grid>
        <Grid item xs="auto">
          <Typography component="span" sx={{ fontSize: 12, fontWeight: 400, color: '#22242C' }}>
            {percent ? `${percent}%` : null}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}

export const AmountUnit = () => {
  const myState = useSelector((state: any) => state.valueConverter);
  const dispatch = useDispatch();

  const handleChange = (event: any) => {
    dispatch({ type: SET_VALUE, value: event.target.value });
  };

  return (
    <>
      <FormControl>
        <Select
          style={{ color: 'var(--title-color)', height: '1.7rem', width: '7rem' }}
          value={myState}
          onChange={handleChange}
          displayEmpty
          inputProps={{ 'aria-label': 'Without label' }}
          variant="standard"
          sx={{
            fontSize: 12,
            lineHeight: '16px',
            color: '#4E5056',
            fontWeight: 500,
            boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.15)',
            borderRadius: '5px',
            pl: 1,
            background: ' #FFFFFF',
          }}>
          <MenuItem value={0} style={{ color: 'var(--title-color)' }}>
            Numbers
          </MenuItem>
          <MenuItem value={1} style={{ color: 'var(--title-color)' }}>
            Crores
          </MenuItem>
          <MenuItem value={2} style={{ color: 'var(--title-color)' }}>
            Lakhs
          </MenuItem>
        </Select>
      </FormControl>
    </>
  );
};

export function YearSelecter(props: any) {
  return (
    <div
      style={{
        cursor: 'pointer',
        flexGrow: 1,
        flexBasis: 0,
        paddingRight: !props.marginH ? props.marginH : 3,
        paddingLeft: !props.marginH ? props.marginH : 3,
        marginLeft: 2,
        marginRight: 2,
        // marginLeft: !!props.marginH ? props.marginH : 3,
        // marginRight: !!props.marginH ? props.marginH : 3,
        borderRadius: 5,
        paddingTop: !props.paddingV ? props.paddingV : 3,
        paddingBottom: !props.paddingV ? props.paddingV : 3,
        backgroundColor: props.isSelected ? '#337FC9' : 'transparent',
        border: '1px solid #163869',
      }}
      onClick={props.onPress}>
      <div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            color: props.isSelected ? '#FFFFFF' : '#5A7C82',
            alignItems: 'center',
          }}>
          {props.text}
        </div>
      </div>
    </div>
  );
}

export function TopHoldingButtons(props: any) {
  return (
    <div
      style={{
        display: 'flex',
        margin: 10,
        marginBottom: 15,
        borderRadius: 18,
        border:
          // props.selected === props.label
          '1px solid #00A4A4',
        backgroundColor: props.selected === props.label ? '#337FC9' : '#FFFFFF',
        color: props.selected === props.label ? '#FFFFFF' : '#337FC9',
        flexGrow: 1,
        flexBasis: 0,
        padding: 6,
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
      }}
      onClick={props.onPress}>
      <div style={{ fontSize: 14, fontWeight: 500 }}>{props.label}</div>
      <div style={{ fontSize: 14, paddingTop: 5 }}>{props.percentage}%</div>
    </div>
  );
}

function CommonLayoutDrawer({ handleDrawerToggle }: { handleDrawerToggle?: () => void }) { //here added the handleDrawerToggle prop for closing the sidebar adter routing
  const history = useHistory();

  const [activeCategory, setActiveCategory] = useState<string>("")

  const { pathname } = useLocation();

  const categoryMap = {
    products: [
      "/product/mutual-fund",
      "/product/direct-equity",
      "/product/pms",
      "/product/debt",
      "/product/alternates",
      "/product/insurance",
    ],
    applications: [
      "/onboarding/enter-pan-number",
      "/applications",
      "/view-consent-email-list",
      "/applications-list",
      // "/create-account",
      // "/account-status",
      "/re-kyc-status",
      "/non-mf-applications",
    ],
    jointHolder: [
      "/create-account",
      "/account-status",
    ],
    reports: [
      '/reports-download/mf-client-statement',
      '/reports-download/mf-transaction-wise-holding-report',
      '/reports-download/holding-report',
      '/reports-download/capital-gain-statement',
      '/reports-download/transaction-history-report',
      "/reports",
    ],
    analytics: [
      "/analytics/mutual-fund-research",
      "/analytics/portfolio-analytics",
      "/analytics/revenue-analytics",
    ],
    orders: [
      "/orders/order-dashboard",
      "/orders/order-entry",
      "/orders-approval"
    ],
    invest: [
      "/investor-dashboard/mutual-fund",
      "/investor-dashboard/direct-equity",
      "/investor-dashboard/pms",
      "/investor-dashboard/debt",
      "/investor-dashboard/alternates",
      "/investor-dashboard/insurance",
    ],
    others: [
      "/investor-reports/client-statement"
    ],
    payments: [
      "/payments-approval"
    ],
    bankLinks: [
      "/bank/updateBank",
      "/bank/viewBank",
    ],
    nomineeLinks: [
      "/nominee/updateNominee"
    ]
  };

  useEffect(() => {
    const activeCategory = Object.entries(categoryMap).find(([_, paths]) =>
      paths.includes(pathname)
    )?.[0] || "";

    setActiveCategory(activeCategory);

  }, [pathname])

  const handleLogoClick = () => {
    history.push('/')
  }

  const sideBarItemsArr = getSideBarData({
    activeCategory,
    setActiveCategory
  })

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        onClick={handleLogoClick}
        sx={{
          width: "12rem",
          height: { xs: '70px', sm: '80px', md: '100px', lg: '120px' },
          margin: "10px 15px 5px 30px",
          cursor: 'pointer',
          backgroundImage: 'url("/images/abcl-wealth-logo.svg")',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      // role="img"
      // aria-label="Logo"
      />
      <List
        sx={{
          ml: '1.5rem',
          mr: '1.5rem',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {sideBarItemsArr
          .filter(obj => !(obj.isSubMenuItem && !obj.subMenuItem.length))
          .map((sideBarItem, index) => {

            if (sideBarItem.isSubMenuItem) {
              return (
                <>
                  <ListItemButton
                    disableRipple
                    onClick={(e) => {
                      if (sideBarItem.menuItem.isDisabled) {
                        e.preventDefault();
                        return;
                      }
                      sideBarItem.menuItem.handleClick();
                    }}
                    sx={{
                      marginTop: `${index !== 0 ? "8px" : "0px"}`,
                      marginBottom: `${activeCategory !== sideBarItem.menuItem.dropdownId ? "8px" : "0px"}`,
                      padding: "10px",
                      "&.Mui-disabled": {
                        pointerEvents: "auto",
                        cursor: "not-allowed",
                      },
                      "&: hover": {
                        backgroundColor: "transparent",
                      },
                    }}
                    disabled={sideBarItem.menuItem.isDisabled}
                  >
                    <ListItemText
                      sx={(theme: Theme) => ({
                        ".MuiTypography-root": {
                          // ...theme.typography.subtitle_500,
                          fontSize: { xs: "12px", md: "14px", xl: "16px" },
                          fontWeight: '600',
                          color: theme.palette.text.primary
                        }
                      })}
                      primary={sideBarItem.menuItem.name}
                    />
                    {
                      (activeCategory === sideBarItem.menuItem.dropdownId) ?
                        <ExpandLessIcon sx={{ color: 'text.primary' }} /> :
                        <ExpandMoreIcon sx={{ color: 'text.primary' }} />
                    }
                  </ListItemButton>
                  <Collapse
                    in={activeCategory === sideBarItem.menuItem.dropdownId}
                    timeout={0}
                  >
                    {sideBarItem.subMenuItem.map(dropdownItem => (
                      <List
                        component="div"
                        key={dropdownItem.name}
                      >
                        <ListItemButton
                          disableRipple
                          sx={(theme: Theme) => ({
                            columnGap: "15px",
                            borderRadius: '15px',
                            padding: "10px",
                            backgroundColor: (dropdownItem.route ?? []).includes(pathname) ? theme.palette.primary[500] : theme.palette.common.white,
                            "&.Mui-disabled": {
                              pointerEvents: "auto",
                              cursor: "not-allowed",
                            },
                            '&:hover': {
                              backgroundColor: dropdownItem.isDisabled ? "transparent" : (dropdownItem.route ?? []).includes(pathname) ? theme.palette.primary[500] : theme.palette.grey[100],
                            },
                          })}
                          onClick={(e) => {
                            if (dropdownItem.isDisabled) {
                              e.preventDefault();
                              return;
                            }
                            dropdownItem.handleClick();
                            handleDrawerToggle?.(); //here added to close the sidebar after routing on mobile
                          }}
                          disabled={dropdownItem.isDisabled}
                        >
                          <ListItemIcon sx={{ minWidth: "0px" }}>
                            {(dropdownItem.route ?? []).includes(pathname) ? dropdownItem.activeIcon : dropdownItem.inActiveIcon}
                          </ListItemIcon>
                          <ListItemText
                            sx={(theme: Theme) => ({
                              ".MuiTypography-root": {
                                // ...theme.typography.subtitle_500,
                                fontSize: { xs: "12px", md: "14px", xl: "16px" },
                                fontWeight: 500,
                                color: (dropdownItem.route ?? []).includes(pathname) ? theme.palette.common.white : theme.palette.text.secondary,
                              }
                            })}
                            primary={dropdownItem.name}
                          />
                        </ListItemButton>
                      </List>
                    ))}
                  </Collapse>
                </>
              )
            } else {
              return (
                <>
                  <ListItemButton
                    disableRipple
                    sx={(theme: Theme) => ({
                      marginTop: `${index !== 0 ? "8px" : "0px"}`,
                      marginBottom: "8px",
                      columnGap: "15px",
                      borderRadius: '15px',
                      padding: "10px",
                      backgroundColor: (sideBarItem.menuItem.route ?? []).includes(pathname) ? theme.palette.primary[500] : theme.palette.common.white,
                      "&.Mui-disabled": {
                        pointerEvents: "auto",
                        cursor: "not-allowed",
                      },
                      '&:hover': {
                        backgroundColor: sideBarItem.menuItem.isDisabled ? "transparent" : (sideBarItem.menuItem.route ?? []).includes(pathname) ? theme.palette.primary[500] : theme.palette.grey[100],
                      },
                    })}
                    onClick={(e) => {
                      if (sideBarItem.menuItem.isDisabled) {
                        e.preventDefault();
                        return;
                      }
                      sideBarItem.menuItem.handleClick();
                      handleDrawerToggle?.();//here added to close the sidebar after routing on mobile
                    }}
                    disabled={sideBarItem.menuItem.isDisabled}
                  >
                    <ListItemIcon
                      sx={{ minWidth: "0px" }}
                    >
                      {(sideBarItem.menuItem.route ?? []).includes(pathname) ? sideBarItem.menuItem.activeIcon : sideBarItem.menuItem.inActiveIcon}
                    </ListItemIcon>
                    <ListItemText
                      primary={sideBarItem.menuItem.name}
                      sx={(theme: Theme) => ({
                        ".MuiTypography-root": {
                          // ...theme.typography.subtitle_500,
                          fontSize: { xs: "12px", md: "14px", xl: "16px" },
                          fontWeight: 500,
                          color: (sideBarItem.menuItem.route ?? []).includes(pathname) ? theme.palette.common.white : theme.palette.text.secondary,
                        }
                      })}
                    />
                  </ListItemButton >
                </>
              )
            }
          })}
      </List>
    </Box >
  );
};

export function CommonLayoutSidenav({
  isMobileDrawerOpen,
  handleMobileDrawerToggle,
}: {
  isMobileDrawerOpen: boolean;
  handleMobileDrawerToggle: () => void;
}): JSX.Element {

  return (
    <Box
      component="nav"
      sx={(theme: Theme) => ({
        [theme.breakpoints.up(1400)]: {
          width: drawerWidth,
          flexShrink: 0
        },
      })}
      aria-label="Side menu"
    >
      {/* Mobile Drawer start */}
      <Drawer
        variant="temporary"
        open={isMobileDrawerOpen}
        onClose={handleMobileDrawerToggle}
        anchor="left"
        ModalProps={{
          keepMounted: true,
        }}
        sx={(theme: Theme) => ({
          display: {
            xs: 'block',
          },
          [theme.breakpoints.up(1400)]: {
            display: "none"
          },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
          },
        })}>
        <CommonLayoutDrawer handleDrawerToggle={handleMobileDrawerToggle} />   {/* here passing the handleDrawerToggle to close the sidebar on mobile after routing */}

      </Drawer>
      {/* Mobile Drawer end */}

      {/* Big Screen Drawer start */}
      <Drawer
        variant="permanent"
        sx={(theme: Theme) => ({
          display: {
            md: 'block'
          },
          [theme.breakpoints.down(1400)]: {
            display: "none"
          },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
            border: 0,
            minHeight: '100vh',
            overflow: 'auto',
          },
          '& .MuiDrawer-paper::-webkit-scrollbar': {
            width: '5px',
          },
          '& .MuiDrawer-paper::-webkit-scrollbar-thumb': {
            backgroundColor: `${theme.palette.common.black}80`,
            borderRadius: '10px',
          },
        })}
        open>
        <CommonLayoutDrawer handleDrawerToggle={handleMobileDrawerToggle} /> {/* here passing the handleDrawerToggle to close the sidebar on mobile after routing */}
      </Drawer>
      {/* Big Screen Drawer end */}
    </Box>
  );
};

export function CommonLayout({ children }: { children: JSX.Element }): JSX.Element {
  const [isMobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  const handleMobileDrawerToggle = () => {
    setMobileDrawerOpen(prevState => !prevState);
  };

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: "column", width: '100%', position: 'relative', minHeight: '100vh' }}>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            mb: 18
          }}
        >
          <CommonLayoutSidenav
            isMobileDrawerOpen={isMobileDrawerOpen}
            handleMobileDrawerToggle={handleMobileDrawerToggle}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              minWidth: 0,
            }}
          >
            <Header handleDrawerToggle={handleMobileDrawerToggle} />
            <Box
              component="main"
              sx={(theme: Theme) => ({
                ml: { xs: 0, md: 0 },
                p: { xs: '0 25px 25px 25px' },
                borderRadius: '50px 0 0 0',
                bgcolor: { xs: '' },
                [theme.breakpoints.down(1400)]: {
                  bgcolor: theme.palette.background.default
                },
              })}
            >
              <Container
                maxWidth={false}
                disableGutters={true}
              >
                {children}
              </Container>
            </Box>
          </Box>
        </Box>
        <PostLoginFooter isMobileDrawerOpen={isMobileDrawerOpen} />
      </Box >
    </>
  );
};


export const AddressUpdatePopup = ({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}): JSX.Element => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '15px',
          backgroundColor: 'background.default',
          width: '536px',
          height: 'auto',
          padding: '25px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }
      }}
    >
      <Formik
        initialValues={{ addressType: 'both' }}
        onSubmit={(values) => {
          onClose();
        }}
      >
        {({ values }) => (
          <Form style={{ height: '100%' }}>
            <DialogContent sx={{ flexGrow: 1, padding: 0, pb: '40px' }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: '33px' }}>
                <Typography variant="h2" sx={{ fontWeight: 600, letterSpacing: '1%' }}>
                  Do you wish to update ?
                </Typography>
              </Box>

              <RadioGroup name="addressType" value={values.addressType} sx={{ gap: '15px' }}>
                <FormControlLabel
                  value="correspondence"
                  control={<Field as={Radio} name="addressType" />}
                  label={<Typography variant='body_500'>Correspondence Address</Typography>}
                />
                <FormControlLabel
                  value="permanent"
                  control={<Field as={Radio} name="addressType" />}
                  label={<Typography variant='body_500'>Permanent Address</Typography>}
                />
                <FormControlLabel
                  value="both"
                  control={<Field as={Radio} name="addressType" />}
                  label={<Typography variant='body_500'>Both</Typography>}
                />
              </RadioGroup>
            </DialogContent>

            <DialogActions sx={{ padding: 0, columnGap: "10px" }}>
              <Button
                variant="outlined"
                // onClick={() => setOpen(false)}
                sx={(theme: Theme) => ({
                  color: theme.palette.text.secondary,
                  flex: 1,
                  border: `0.5px solid ${theme.palette.text.secondary}`,
                  padding: "10px",
                  "&:hover, &.Mui-focusVisible": {
                    borderColor: theme.palette.text.secondary,
                    backgroundColor: theme.palette.background.default
                  }
                })}
              >
                {'No'}
              </Button>
              <Button
                variant="contained"
                sx={(theme: Theme) => ({
                  flex: 1,
                  color: theme.palette.textDark.primary,
                  padding: "10px"
                })}
              // onClick={() => handleDialogSave(setValues, values)}
              >
                {'Yes'}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}

export function CustomInvestorLayout({ children }: { children: JSX.Element }): JSX.Element {

  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const { token = '', } = useSelector((store: RootStateType) => store.auth);
  const { applicationId: id = '' } = useSelector((store: RootStateType) => store.id);
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const { palette } = useTheme();
  const menuOpen = Boolean(menuAnchorEl);

  const handleProfileLogout = () => {
    if (token) {
      dispatch(logout());
    }

    dispatch({ type: LOGOUT_SUCCESS })
    history.push('/login');
  }

  return (
    <Stack
      sx={{
        minHeight: '100vh',
        background: '#f2f6f8 url("/images/abcl-newbg.svg")',
        backgroundSize: 'cover',
      }}
    >
      <AppBar elevation={0} position="static" sx={{ bgcolor: 'transparent' }}>
        <Box sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}>
          <Box>
            <CardMedia
              component="img"
              // onClick={() => history.push('/')}
              src="/images/abcl-wealth-logo.svg"
              alt="Logo"
              sx={{
                margin: "15px 0px 0px 15px",
                cursor: 'pointer',
                width: '12rem',
              }}
            />
          </Box>
          <Box sx={{
            display: { xs: 'flex' },
            alignItems: 'center',
            pr: { xs: 2, md: 3 },
          }}>
            <IconButton
              sx={{ padding: 0, ml: 1.5 }}
              onClick={(e) => setMenuAnchorEl(e.currentTarget)}
            >
              <ProfileIcon />
            </IconButton>

          </Box>
        </Box>
      </AppBar>
     <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </Box>
      <Menu
        anchorEl={menuAnchorEl}
        open={menuOpen}
        onClose={() => setMenuAnchorEl(null)}
        MenuListProps={{
          'aria-labelledby': 'logout-button',
          sx: {
            padding: "8px 0px",
          }
        }}
        slotProps={{
          paper: {
            style: {
              width: '200px',
              borderRadius: "12px",
              backgroundColor: palette.common.white,
            }
          }
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}

      >
        <MenuItem
          onClick={() => {
            handleProfileLogout()
          }}
        >
          Logout
        </MenuItem>
      </Menu >

      <Footer />
    </Stack>
  );
}

export function NomineeTable({ data }: { data: Partial<NomineeType>[] }): JSX.Element {
  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        overflowX: "auto",
        borderRadius: 1,
        border: "1px solid",
        borderColor: "grey.200",
      }}
    >
      <Table
        aria-label="nominee-table"
        stickyHeader
        sx={{
          minWidth: 650,
          tableLayout: "fixed",
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "25%" }}>Name</TableCell>
            <TableCell sx={{ width: "25%" }} align="center">Relationship</TableCell>
            <TableCell sx={{ width: "20%" }} align="center">Percentage</TableCell>
            <TableCell sx={{ width: "30%" }} align="right">Guardian Name</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {row.nomineeName || "—"}
              </TableCell>

              <TableCell align="center" sx={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                {row.nomineeRelationship || "—"}
              </TableCell>

              <TableCell align="center">{row.nomineePercentage || "—"}</TableCell>

              <TableCell
                align="right"
                sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
              >
                {row.guardianName || "—"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
export const InvestorSidenav = ({
  mobileOpen,
  setMobileOpen,
  handleDrawerToggle,
  handleToggle
}: {
  mobileOpen: boolean;
  setMobileOpen: Dispatch<SetStateAction<boolean>>;
  handleDrawerToggle: () => void;
  handleToggle: () => void;
}): JSX.Element => {
  return (
    <>
      <Box
        component="nav"
        sx={(theme: Theme) => ({
          // width: { md: drawerWidth },
          // flexShrink: { md: 0 },
          [theme.breakpoints.up(1400)]: {
            width: drawerWidth,
            flexShrink: 0
          },
        })}
        aria-label="side nav">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          anchor="left"
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={(theme: Theme) => ({
            display: {
              xs: 'block',
              // md: 'none' 
            },
            [theme.breakpoints.up(1400)]: {
              display: "none"
            },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          })}>
          <CommonLayoutDrawer handleDrawerToggle={handleDrawerToggle} /> {/* here passing the handleDrawerToggle to close the sidebar on mobile after routing */}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={(theme: Theme) => ({
            display: {
              // xs: 'none', 
              md: 'block'
            },
            [theme.breakpoints.down(1400)]: {
              display: "none"
            },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              border: 0,
              minHeight: '100vh',
              overflow: 'auto',
            },
            '& .MuiDrawer-paper::-webkit-scrollbar': {
              width: '5px', // Width of the scrollbar
            },
            '& .MuiDrawer-paper::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(0, 0, 0, 0.5)', // Color of the scrollbar thumb
              borderRadius: '10px', // Rounded corners of the scrollbar thumb
            },
          })}
          open>
          <CommonLayoutDrawer handleDrawerToggle={handleDrawerToggle} /> {/* here passing the handleDrawerToggle to close the sidebar on mobile after routing */}
        </Drawer>
      </Box>
    </>
  );
};

export function BanksTable({ data }: { data: Partial<Bank>[] }): JSX.Element {
  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        overflowX: "auto",
        borderRadius: 1,
        border: "1px solid",
        borderColor: "grey.200",
      }}
    >
      <Table
        aria-label="banks-table"
        stickyHeader
        sx={{
          minWidth: 650,
          tableLayout: "fixed",
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "25%" }}>BankName</TableCell>
            <TableCell sx={{ width: "30%" }} align="center">Bank Account Number</TableCell>
            <TableCell sx={{ width: "20%" }} align="center">IFSC Code</TableCell>
            <TableCell sx={{ width: "30%" }} align="right">Default Bank Account</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell sx={{ whiteSpace: "nowrap", overflow: "hidden" }}>
                {row.bankName || "—"}
              </TableCell>

              <TableCell align="center" sx={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                {row.bankAccountNumber || "—"}
              </TableCell>

              <TableCell align="center">{row.ifscCode || "—"}</TableCell>

              <TableCell
                align="right"
                sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}
              >
                {row.defaultBankAccount ? "Yes" : "—"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export const CommonLayoutForInvestor = ({ children }: { children: JSX.Element }): JSX.Element => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleToggle = () => {
    setMobileOpen(false);
  }
  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: "column", width: '100%', position: 'relative', minHeight: '100vh' }}>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            mb: 18
          }}
        >
          <InvestorSidenav
            mobileOpen={mobileOpen}
            setMobileOpen={setMobileOpen}
            handleDrawerToggle={handleDrawerToggle}
            handleToggle={handleToggle}
          />
          <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minWidth: 0 }}>
            <Header handleDrawerToggle={handleDrawerToggle} />
            <Box
              component="main"
              sx={(theme: Theme) => ({
                flex: 1,
                // mt: '15px',
                ml: { xs: 0, md: 0 },
                p: { xs: '0 15px 25px 15px', sm: '0 25px 25px 25px' },
                borderRadius: '50px 0 0 0',
                // bgcolor: { xs: '', md: 'rgba(247, 247, 247, 1)' },
                bgcolor: { xs: '' },
                [theme.breakpoints.down(1400)]: {
                  bgcolor: theme.palette.background.default
                },
              })}>
              {/* <Container maxWidth="lg" disableGutters={true}
                sx={(theme: Theme) => ({
                  [theme.breakpoints.up('xl')]: {
                    maxWidth: '100%',
                  }
                })}>
                {children}
              </Container> */}
              <Container maxWidth={false} disableGutters={true}>
                {children}
              </Container>
            </Box>
          </Box>
        </Box>
        <PostLoginFooter isMobileDrawerOpen={mobileOpen} />
      </Box>
    </>
  );
};
export const BreadCrumbsComponent = ({ data }: { data: string[] }): JSX.Element => {
  const theme = useTheme();
  const history = useHistory();

  const handleNavigate = (idx: number) => {
    if (idx === data.length - 1) return;
    for (let i = idx; i < data.length - 1; i++) {
      history.goBack();
    }
  }

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
      {data.map((d: string, idx: number) => (
        <Link key={idx} underline="hover" sx={{ cursor: idx === data.length - 1 ? "default" : "pointer", color: idx === data.length - 1 ? theme.palette.primary[500] : "inherit" }} onClick={() => handleNavigate(idx)}>
          {d}
        </Link>
      ))
      }
    </Breadcrumbs >
  );
};
